import {
  type ConfirmDialogActionsProps,
  type ConfirmDialogContentProps
} from '../components/ConfirmDialog'

import {ConfirmDialog} from '@refra/modules/common/components/ConfirmDialog/ConfirmDialog'
import {useRefraModal} from '@refra/modules/common/providers'

export interface ConfirmDialogDetails extends ConfirmDialogActionsProps, ConfirmDialogContentProps {
  title: string
  testId?: string
}

export const useConfirmDialog = () => {
  const {openModal, closeModal} = useRefraModal()

  const openConfirmDialog = (props: ConfirmDialogDetails) => {
    openModal(<ConfirmDialog {...{...props, closeModal}} />)
  }

  return {openDialog: openConfirmDialog, closeDialog: closeModal}
}
